import { render, staticRenderFns } from "./people_edit_modal.vue?vue&type=template&id=1f0f2577&"
import script from "./people_edit_modal.vue?vue&type=script&lang=js&"
export * from "./people_edit_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports